import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon, Link } from '../index';
import css from './styles.scss';

const Banner = (props) => {
  const {
    title, message, type, icon, action, actionAlignment,
  } = props;
  const getBannerIcon = () => {
    if (icon) {
      return icon;
    }

    if (type === 'warning') {
      return 'warningRectangle';
    }

    if (type === 'alert') {
      return 'warningSolid';
    }

    if (type === 'success') {
      return 'completeHollow';
    }

    if (type === 'disabled') {
      return 'infoHollow';
    }
    return 'infoHollow';
  };

  const rootClasses = classNames({
    [css.bannerContainer]: true,
    [css['banner--info']]: type === 'info',
    [css['banner--warning']]: type === 'warning',
    [css['banner--alert']]: type === 'alert',
    [css['banner--success']]: type === 'success',
    [css['banner--disabled']]: type === 'disabled',
  });

  const iconClasses = classNames({
    [css['icon--info']]: type === 'info',
    [css['icon--warning']]: type === 'warning',
    [css['icon--alert']]: type === 'alert',
    [css['icon--success']]: type === 'success',
    [css['icon--disabled']]: type === 'disabled',
  });

  return (
    <div className={rootClasses}>
      <span className={iconClasses}>
        <Icon name={getBannerIcon()} size={22} block />
      </span>
      <span className={css.bannerText}>
        {!!title
            && (
            <div className={css.bannerTitle}>
              {title}
            </div>
            )}
        {!!message
            && (
            <div>
              {message}
            </div>
            )}
        {action && (
          <div className={classNames(css.bannerActions, {
            [css['bannerActions--left']]: actionAlignment === 'left',
            [css['bannerActions--right']]: actionAlignment === 'right',
          })}
          >
            <Link
              href={action.href}
              onClick={action.onClick}
              target={action.target}
            >
              {action.text}
            </Link>
          </div>
        )}
      </span>
    </div>
  );
};

Banner.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.oneOf([
    'info',
    'warning',
    'alert',
    'success',
    'disabled',
  ]),
  action: PropTypes.shape({
    text: PropTypes.string.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func,
    target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  }),
  actionAlignment: PropTypes.oneOf(['left', 'right']),
};

Banner.defaultProps = {
  title: '',
  message: '',
  icon: '',
  type: 'info',
  action: null,
  actionAlignment: 'right',
};

export default Banner;
